import React, { FunctionComponent } from "react"
import FormInput from "../../../components/Form/Inputs/FormInput"
import Upload from "../../../components/Upload/Upload"
import { iExhibition } from "../../../definitions/Exhibition"

interface iUploadsProps {
  item?: iExhibition
}

const ExhibitionUploads: FunctionComponent<iUploadsProps> = ({
  item = {} as iExhibition,
}) => {
  return (
    <div className="scrollable">
      <Upload
        name={"posterImageId"}
        fileCollection={"Files_ExhibitionPosters"}
        maxFiles={1}
        initialFiles={[item?.posterImageId || ""]}
        fileType={["image/png", "image/jpeg"]}
        label="Upload poster"
      />
      <Upload
        name={"screenshotIds"}
        fileCollection={"Files_ExhibitionScreenshots"}
        maxFiles={5}
        initialFiles={item.screenshotIds}
        fileType={["image/png", "image/jpeg"]}
        label="Upload screenshots"
      />
      <Upload
        name={"mesh"}
        fileCollection={"Files_Meshes"}
        maxFiles={1}
        initialFiles={[item?.mesh || ""]}
        label="Upload mesh"
      />
      <FormInput name="meshguid" label="Mesh GUID" />
    </div>
  )
}

export default ExhibitionUploads
